import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalComponent } from '../components/modal.component';


@NgModule({
  declarations: [
      ModalComponent,
 
  ],
  imports:[
    CommonModule,
    FormsModule 

  ],
  exports:[
     ModalComponent
  ]
})
export class ModalModule { }
